// extracted by mini-css-extract-plugin
export default {"app_policy":"Policy_app_policy__Kvt1y"};